import styled from 'styled-components';

export const StyledImage = styled.img`
  width: 8rem;
`;
